//@ts-ignore
import React from "react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";
import RemarkApp from "@tuteria/shared-lib/src/admin/Remark";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
// declare global {
//   interface Window {
//     $: any;
//   }
// }

const RenderItemInPortal = ({ domNode, component }) => {
  return ReactDOM.createPortal(component, domNode);
};

const RenderAllComponents: React.FC<any> = ({
  components = [],
  nodes = [],
}) => {
  return (
    <>
      {components.map((o: any, i: any) => (
        <RenderItemInPortal key={i} domNode={nodes[i]} component={o} />
      ))}
    </>
  );
};

export function initializeAdmin(
  actions,
  baseUrl = "",
  selector = "td.field-remarks",
  childNode
) {
  function onUpdateRemark(request_id, fields) {
    let request = new Request(baseUrl, {
      method: "post",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...fields, user_id: request_id }),
    });
    return fetch(request)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        return response.data;
      });
  }
  let components = [];
  let domNodes = document.querySelectorAll(selector);
  Array.from(domNodes).forEach((node) => {
    let text = node.innerHTML;
    let id = window
      .$(node)
      .siblings()
      .find("input[name=_selected_action]")
      .val();
    let nn = (
      <>
        <div dangerouslySetInnerHTML={{ __html: text }} />
        <RemarkApp
          content={""}
          onUpdateRemark={onUpdateRemark}
          actions={actions}
          request_id={id}
          childNode={childNode}
        />
      </>
    );
    components.push(nn);
  });
  if (childNode) {
    ReactDOM.render(
      <ThemeProvider>
        <RenderAllComponents components={components} nodes={domNodes} />
      </ThemeProvider>,
      childNode
    );
  }
}
